import { useFormik } from "formik";
import * as Yup from "yup";
import { Link as ReactLink } from "react-router-dom";
import { Box, Button, Stack, TextField, Typography } from "@mui/material";
import { useForgotPasswordMutation } from "@/app/features/auth/authApiSlice";
import useSnackbar from "@/hooks/use-snackbar";

function ForgotPasswordPage() {
  const { showSnackbar, snackbar } = useSnackbar();
  const [forgotPassword, { isLoading }] = useForgotPasswordMutation();

  const formik = useFormik({
    initialValues: {
      email: "",
      submit: null,
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Must be a valid email")
        .max(255)
        .required("Email is required"),
    }),
    onSubmit: async (values, helpers) => {
      try {
        const { data, error } = await forgotPassword({
          email: values.email,
        });

        if (error) {
          helpers.setStatus({ success: false });
          helpers.setErrors({ submit: error?.data?.message });
          helpers.setSubmitting(false);
          return;
        }

        showSnackbar({ message: data?.message });
      } catch (err) {
        helpers.setStatus({ success: false });
        helpers.setErrors({ submit: err.message });
        helpers.setSubmitting(false);
      }
    },
  });

  return (
    <Box
      sx={{
        backgroundColor: "background.paper",
        flex: "1 1 auto",
        alignItems: "center",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          maxWidth: 550,
          px: 3,
          py: "100px",
          width: "100%",
        }}
      >
        {snackbar}
        <div>
          <Stack spacing={1} sx={{ mb: 3 }}>
            <Typography variant="h4">Forgot Password</Typography>
          </Stack>

          <form noValidate onSubmit={formik.handleSubmit}>
            <Stack spacing={3}>
              <TextField
                error={!!(formik.touched.email && formik.errors.email)}
                fullWidth
                helperText={formik.touched.email && formik.errors.email}
                label="Email Address"
                name="email"
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                type="email"
                value={formik.values.email}
              />
            </Stack>
            {formik.errors.submit && (
              <Typography color="error" sx={{ mt: 3 }} variant="body2">
                {formik.errors.submit}
              </Typography>
            )}

            <Button
              fullWidth
              size="large"
              sx={{ mt: 3 }}
              type="submit"
              variant="contained"
              disabled={isLoading}
            >
              Send Link
            </Button>
            <Button
              fullWidth
              size="large"
              sx={{ mt: 3 }}
              component={ReactLink}
              to="/"
            >
              Go back got Login
            </Button>
          </form>
        </div>
      </Box>
    </Box>
  );
}

export default ForgotPasswordPage;
